import { combineReducers } from 'redux';
import { i18nReducer, I18nState } from 'react-redux-i18n';
import { routerReducer, RouterState } from 'react-router-redux';
import { appInfos, AppInfosState } from '../containers/App/reducer';
import { galleryInfos, GalleryInfosState } from '../containers/Gallery/reducer';
import { authentication, AuthenticationState } from '../containers/Authentication/reducer';
import { driveList, DriveListState } from '../containers/DriveItemList/reducer';
import { newDriveItems, NewDriveItemsState } from '../containers/DriveItemList/New/reducer';
import { search, SearchDriveItemState } from '../containers/DriveItemList/Search/reducer';
import { downloadManager, DownloadManagerState } from '../containers/DownloadManager/reducer';
import { notificationBar, NotificationBarState } from '../containers/NotificationBar/reducer';
import { multiAppAuthenticationInfos, MultiAppAuthenticationInfosState } from '../containers/MultiAppAuthentication/reducer';
import { selection, SelectionState } from '../containers/Selection/reducer';
import { offlineManager, OfflineManagerState } from '../containers/OfflineManager/reducer';
import { pendingTasksManager, PendingTasksManagerState } from '../containers/PendingTasksManager/reducer';
import { parametersPage, ParametersPageState } from '../containers/ParametersPage/reducer';
import { routerParamsHistory, RouterParamsState } from '../containers/SetRouteParams/reducer';
import { sharePanel, SharePanelState } from '../containers/Share/reducer';
import { folderCreationPanel, FolderCreationPanelState } from '../containers/FolderCreationPanel/reducer';
import { menuManager, MenuState } from '../containers/MenuManager/reducer';
import { downloadAllPopup, DownloadAllPopupState } from '../containers/DownloadAllPopup/reducer';
import { GDPRCookie, GDPRCookieState } from '../containers/CookieNotification/GDPRCookie/reducer';
import { readStatus, ReadItemsListState } from '../containers/ReadStatus/reducer';
import { editor, EditorState } from '../containers/Editor/reducer';
import { importManager, ImportManagerState } from '../containers/ImportManager/reducer';
import { publicationCreator, PublicationCreatorState } from '../containers/PublicationCreator/reducer';
import { assetRenamePanel, AssetRenamePanelState } from '../containers/AssetRenamePanel/reducer';
import { externalLinkCreationPanel, ExternalLinkCreationPanelState } from '../containers/ExternalLinkCreationPanel/reducer';
import { profile, ProfileState } from '../containers/ProfilePage/reducer';
import { proposalStats, ProposalStatsState } from '../containers/ProposalStatsPage/reducer';
import { noSaveAsPopup, NoSaveAsPopupState } from '../containers/NoSaveAsPopup/reducer';
import { notes, NotesState } from '../containers/NotesPage/reducer';
import { backToPublication, BackToPublicationState } from '../containers/BackToPublication/reducer';
import { shareWithUserPopup, ShareWithUserPopupState } from '../containers/ShareWithUserPopup/reducer';
import { coverImagePanel, CoverImagePanelState } from '../containers/CoverImagePanel/reducer';

export interface StoreState {
	appInfos: AppInfosState;
	authentication: AuthenticationState;
	downloadAllPopup: DownloadAllPopupState;
	downloadManager: DownloadManagerState;
	driveList: DriveListState;
	folderCreationPanel: FolderCreationPanelState;
	galleryInfos: GalleryInfosState;
	i18n: I18nState;
	menuManager: MenuState;
	multiAppAuthenticationInfos: MultiAppAuthenticationInfosState;
	newDriveItems: NewDriveItemsState;
	noSaveAsPopup: NoSaveAsPopupState;
	notificationBar: NotificationBarState;
	offlineManager: OfflineManagerState;
	parametersPage: ParametersPageState;
	pendingTasksManager: PendingTasksManagerState;
	readStatus: ReadItemsListState;
	routerParamsHistory: RouterParamsState[];
	routing: RouterState;
	search: SearchDriveItemState;
	selection: SelectionState;
	sharePanel: SharePanelState;
	GDPRCookie: GDPRCookieState;
	editor: EditorState;
	importManager: ImportManagerState;
	publicationCreator: PublicationCreatorState;
	assetRenamePanel: AssetRenamePanelState;
	externalLinkCreationPanel: ExternalLinkCreationPanelState;
	profile: ProfileState;
	proposalStats: ProposalStatsState;
	notes: NotesState;
	backToPublication: BackToPublicationState;
	shareWithUserPopup: ShareWithUserPopupState;
	coverImagePanel: CoverImagePanelState;
}

const rootReducer = combineReducers<StoreState>({
	appInfos,
	authentication,
	downloadAllPopup,
	downloadManager,
	driveList,
	folderCreationPanel,
	galleryInfos,
	i18n: i18nReducer,
	menuManager,
	multiAppAuthenticationInfos,
	newDriveItems,
	noSaveAsPopup,
	notificationBar,
	offlineManager,
	parametersPage,
	pendingTasksManager,
	readStatus,
	routerParamsHistory,
	routing: routerReducer,
	search,
	selection,
	sharePanel,
	GDPRCookie,
	editor,
	importManager,
	publicationCreator,
	assetRenamePanel,
	externalLinkCreationPanel,
	profile,
	proposalStats,
	notes,
	backToPublication,
	shareWithUserPopup,
	coverImagePanel,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/reducers/index.ts